import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { StoreService } from '../../../ngrx/store.service';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate, CanActivateChild, CanLoad {
  /**
   * Constructor
   */
  constructor(private readonly _authService: AuthService, private readonly _router: Router,
              private readonly storeService:StoreService) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Can activate
   *
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this._check(state.url);
  }

  /**
   * Can activate child
   *
   * @param childRoute
   * @param state
   */
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._check(state.url);
  }

  /**
   * Can load
   *
   * @param route
   * @param segments
   */
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this._check('/');
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Check the authenticated status
   *
   * @private
   */
  private _check(redirectURL: string): Observable<boolean> {
    // Check the authentication status
    return this._authService.check().pipe(     
      switchMap(authenticated => {
        if (!authenticated) {
                return of(true);
        }
        // If the user is authenticated...
        else {

            let hasToken = this._authService.hasToken();
            let isTokenExpired = this._authService.isTokenExpired();
            let user = this.storeService.getConnectedUser();
           if (hasToken && isTokenExpired) {
            return this._authService.signInUsingToken();
               //this._router.navigate(['/sign-in']);
               //return of(true);
           }
             if (redirectURL === '/sign-in' && hasToken && !isTokenExpired ) {
              //&& user.onSICA === 'True') {// enable ACEP users
                // Redirect to the root
                this._router.navigate(['/dashboard']);
                return of(true);
              } else {
                // Allow the access
                return of(true);
              }    
        }
      })
    );
  }
}
